/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { comboCalculationModifierSchema } from "./comboCalculationModifierSchema.ts";

export const comboCalculationGroupModifierSchema = z.object({
	group: z.uuid(),
	modifiers: z.array(comboCalculationModifierSchema),
});
